import { NetworkService } from './network.service';

export default angular
  .module('sfMobile.services.network', [])
  .factory('networkService', NetworkService).name;
